import { type FC } from 'react';

import { CarouselMainContainer } from 'shared/components/Carousel';
import { CarouselMainV2Container, BLOCK_ID as MAIN_CAROUSEL_BLOCK_ID } from 'shared/components/CarouselMainV2';
import { AdfoxPixelContainer } from 'shared/containers/AdfoxPixel';
import { Promos } from 'shared/containers/Promos';
import { MortgageCalculatorContainer } from 'shared/packages/mortgage-calculator';
import { useApplicationContext } from 'shared/utils/applicationContext';

import { AboutContainer } from '../About';
import { AwardsContainer } from '../Awards';
import { ContentWrapper, UnguardedBlock } from '../ContentWrapper';
import { FactsContainer } from '../Facts';
import { HeaderContainer } from '../Header';
import { HeaderV2Container } from '../HeaderV2';
import { PikHistoryContainer } from '../PikHistory';
import { PikInNumbersContainer } from '../PikInNumbers';
import { BLOCK_ID as PIK_IN_NUMBERS_BLOCK_ID, PikInNumbersV2Container } from '../PikInNumbersV2';
import { PikProjectsContainer } from '../PikProjects';
import { RatingsContainer } from '../Ratings';
import { SeriaPlusContainer } from '../SeriaPlus';
import { BLOCK_ID as SERIA_PLUS_BLOCK_ID, SeriaPlusV2Container } from '../SeriaPlusV2';
import { EnvironmentForLifeAndBusinessContainer, ProductFeaturesOfTheQuarters } from '../SliderBlockTypeOne';
import { BLOCK_ID as SMART_HOME_BLOCK_ID, SmartHomeContainer } from '../SmartHome';

export const ApplicationContent: FC = () => {
  const { config } = useApplicationContext();

  const designV2EnabledBlocks = config.get<string[]>('Martech.PikLanding.DesignV2.EnabledBlocks') ?? [];

  const isDesignV2Enabled = designV2EnabledBlocks.length > 0;
  const isBlockV2Enabled = (blockId: string): boolean => designV2EnabledBlocks.includes(blockId);
  const isMainCarouselV2Enabled = isBlockV2Enabled(MAIN_CAROUSEL_BLOCK_ID);
  const isEnvironmentV2Enabled = isBlockV2Enabled('environment-for-life-and-business');

  return (
    <main data-testid="ApplicationContent">
      {isMainCarouselV2Enabled ? (
        <>
          <HeaderV2Container />
          <CarouselMainV2Container />
        </>
      ) : (
        <CarouselMainContainer />
      )}
      <ContentWrapper topOffset={isMainCarouselV2Enabled ? 'content' : 'header'}>
        {isMainCarouselV2Enabled ? null : <HeaderContainer />}
        <FactsContainer />
        <Promos />
        <UnguardedBlock>
          <PikProjectsContainer />
        </UnguardedBlock>
        {isBlockV2Enabled(SERIA_PLUS_BLOCK_ID) ? <SeriaPlusV2Container /> : <SeriaPlusContainer />}
        <MortgageCalculatorContainer />
        {isBlockV2Enabled(PIK_IN_NUMBERS_BLOCK_ID) ? null : <PikInNumbersContainer />}
        <EnvironmentForLifeAndBusinessContainer isDesignV2Enabled={isEnvironmentV2Enabled} />
        {!isEnvironmentV2Enabled ? <ProductFeaturesOfTheQuarters /> : null}
        {isBlockV2Enabled(SMART_HOME_BLOCK_ID) ? <SmartHomeContainer /> : null}
        {isBlockV2Enabled(PIK_IN_NUMBERS_BLOCK_ID) ? <PikInNumbersV2Container /> : null}
        {isDesignV2Enabled ? null : <PikHistoryContainer />}
        <RatingsContainer />
        <AwardsContainer />
        {isDesignV2Enabled ? null : <AboutContainer />}
        <AdfoxPixelContainer />
      </ContentWrapper>
    </main>
  );
};
